// import components
import { styled, Box } from '@mui/material';

export const StyledOuterBox = styled(Box)(({ theme }) => ({
  '& li': {
    borderBottom: `1px solid ${theme.palette.divider}`
  }
}));
